module.exports = __webpack_public_path__ + "static/img-featured-contributor-madeline-aec5fca78d4b18447be90f8bb8d42d5d.jpg";